import {
    FETCH_POPUP_DATA,
    FETCH_SLIDER_DATA,
    FETCH_INFORMASI_CARDS,
    FETCH_LAYANAN_UTAMA,
    FETCH_PANDUAN_LAYANAN,
    FETCH_LAYANAN_PENUNJANG,
    FETCH_BERITA_TERKINI,
    FETCH_AGENDA_TERKINI,
    FETCH_DOKUMENTASI_KEGIATAN,
    FETCH_JEJARING_INSTANSI
} from '../actions/types';

const initialState = {
    popupData: null,
    sliderData: [],
    informasiCards: [],
    layananUtama: [],
    panduanLayanan: [],
    layananPenunjang: [],
    beritaTerkini: [],
    agendaTerkini: [],
    dokumentasiKegiatan: [],
    jejaringInstansi: [],
    loading: false,
    error: null
};

export default function dataReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_POPUP_DATA:
            return { ...state, popupData: action.payload };
        case FETCH_SLIDER_DATA:
            return { ...state, sliderData: action.payload };
        case FETCH_INFORMASI_CARDS:
            return { ...state, informasiCards: action.payload };
        case FETCH_LAYANAN_UTAMA:
            return { ...state, layananUtama: action.payload };
        case FETCH_PANDUAN_LAYANAN:
            return { ...state, panduanLayanan: action.payload };
        case FETCH_LAYANAN_PENUNJANG:
            return { ...state, layananPenunjang: action.payload };
        case FETCH_BERITA_TERKINI:
            return { ...state, beritaTerkini: action.payload };
        case FETCH_AGENDA_TERKINI:
            return { ...state, agendaTerkini: action.payload };
        case FETCH_DOKUMENTASI_KEGIATAN:
            return { ...state, dokumentasiKegiatan: action.payload };
        case FETCH_JEJARING_INSTANSI:
            return { ...state, jejaringInstansi: action.payload };
        default:
            return state;
    }
}